import { memdbRequest, memdbRequestV3 } from "./index.js";
export const registrationCheckStatusCodes = {
    allowed: 1,
    existingRegistration: 5,
    becomesMain: 10,
    becomesSecondary: 20,
};
export function getMemberV3(memberId) {
    return memdbRequestV3.get(`/members/${memberId}`);
}
export function getClubMemberRegistrationPreviewV3(clubId, memberId, registrationStartDate) {
    return memdbRequestV3.get(`/clubs/${clubId}/members/${memberId}/registration-preview`, registrationStartDate ? { params: { registrationStartDate } } : undefined);
}
export function saveClubMemberRegistrationV3(clubId, memberId, registration) {
    return memdbRequestV3.putWithStatus(`/clubs/${clubId}/members/${memberId}/registration`, {
        headers: { "content-type": "application/json" },
        body: JSON.stringify(registration),
    });
}
export function getClubMembersV3(clubId, year) {
    return memdbRequestV3.get(`/clubs/${clubId}/members`, {
        params: { year },
    });
}
export function createClubMemberV3(clubId, member) {
    return memdbRequestV3.post(`/clubs/${clubId}/members`, {
        headers: { "content-type": "application/json" },
        // Pass JSON as a string because the shared client form-encodes object bodies.
        body: JSON.stringify(member),
    });
}
export function searchMembers({ q, limit = 20, }) {
    const term = q.trim();
    if (term.length < 2)
        return Promise.resolve([]);
    return memdbRequestV3.get("/members", {
        params: { q: term, limit: Math.max(1, Math.min(limit, 100)) },
    });
}
export function searchClubMemberRegistrationCandidates({ clubId, q, limit = 20, registrationStartDate, }) {
    const term = q.trim();
    if (term.length < 2) {
        return Promise.resolve([]);
    }
    return memdbRequestV3.get(`/clubs/${clubId}/members/registration-previews`, {
        params: {
            q: term,
            limit: Math.max(1, Math.min(limit, 100)),
            ...(registrationStartDate && { registrationStartDate }),
        },
    });
}
export var Sex;
(function (Sex) {
    // BothSex = -1,
    Sex[Sex["Male"] = 0] = "Male";
    Sex[Sex["Female"] = 1] = "Female";
    Sex[Sex["Unknown"] = 2] = "Unknown";
})(Sex || (Sex = {}));
export function getMember(id, schema, headers) {
    return memdbRequest.get(`/member/${id}`, {
        params: { schema },
        headers,
    });
}
export function getMembers(params) {
    const id = params.id;
    if (Array.isArray(id)) {
        return memdbRequest.get("/member", {
            params: {
                ...params,
                id: id.toString(),
            },
        });
    }
    return memdbRequest.get("/member", { params });
}
export function getFidePlayer({ fideId, ...params }) {
    return memdbRequest.get(`/fideplayer/${fideId}`, { params });
}
export function getFidePlayerV3(fideId) {
    return memdbRequestV3.get(`/fide-players/${fideId}`);
}
export function searchFidePlayers({ firstName, lastName, page = 0, size = 20, }) {
    return memdbRequestV3.get("/fide-players", {
        params: {
            firstName: firstName?.trim() || undefined,
            lastName: lastName?.trim() || undefined,
            page,
            size,
        },
    });
}
export function createMember({ clubid, password, ignoreDupe, ...member }) {
    return memdbRequest.post("/member", {
        body: {
            member,
            clubid,
            ignoreDupe,
            ...(password && {
                password,
                password2: password,
            }),
        },
    });
}
export const updateMember = ({ clubid, ...member }) => {
    return memdbRequest.post(`/member/${member.id}`, { params: { clubid }, body: { member } });
};
export const setMemberPassword = ({ id, password, token, }) => memdbRequest.post(`/member/${id}`, {
    ...(token && {
        headers: {
            token,
        },
    }),
    body: {
        password,
        password2: password,
    },
});
export const login = async ({ email, password, origin, }) => {
    const [value, loginAs] = email.split(":");
    return memdbRequest.post("/login", {
        ...(origin && { headers: { origin } }),
        body: {
            [Number.isNaN(+value) ? "email" : "id"]: Number.isNaN(+value)
                ? value
                : +value,
            password,
            loginAs,
        },
    });
};
export const recoverPassword = async (params) => memdbRequest.get("member/recoverpassword", { params });
//# sourceMappingURL=member.js.map